import { FC } from 'react';

import { s } from 'utilities/strings';

import { IHiddenProps } from './types/hidden.props';

import cssClasses from './hidden.module.scss';

const Hidden: FC<IHiddenProps> = ({ count }) => {
  return <div className={cssClasses.hidden}>{`+${count} ${s(['Site.More'])}`}</div>;
};

export default Hidden;
